import { useRBACCheck } from "@hooks:useRBAC";
import { ReactNode } from "react";

import { RBACAction, RBACResource } from "@:rbac";

interface PermissionRouteProps {
  action: RBACAction;
  resource: RBACResource;
  nextNoPerm: ReactNode;
  nextWithPerm: ReactNode;
}

export const PermissionRoute = ({
  action,
  resource,
  nextNoPerm,
  nextWithPerm,
}: PermissionRouteProps) => {
  const hasPermission = useRBACCheck(action, resource);

  return hasPermission ? nextWithPerm : nextNoPerm;
};
